import { CSS } from "../../constants/css";
import { cookieConsentManager } from "../../utils/cookieConsentManager";

const instance = ($el: HTMLElement) => {
  const dom = {
    $allowMarketingCookies: $el.querySelector<HTMLButtonElement>(".js-allow-marketing-cookies"),
    $consentPanel: $el.querySelector<HTMLDivElement>(".js-marketing-cookie-consent"),
    $link: $el.querySelector<HTMLAnchorElement>(".js-video-with-facade-link"),
    $img: $el.querySelector<HTMLImageElement>(".js-video-with-facade-img"),
    $iframe: $el.querySelector<HTMLIFrameElement>(".js-video-with-facade-iframe"),
  };

  const enableCookieGate = !!dom.$consentPanel;

  const showMarketingPrompt = () => {
    dom.$consentPanel?.classList.remove(CSS.cookieConsent);

    // Hide video content when marketing consent is denied
    if (dom.$iframe && dom.$link) {
      dom.$iframe.src = "";
      dom.$link.classList.remove(CSS.videoPlaying);
      dom.$iframe.setAttribute("tabindex", "-1");
    }
  };

  const hideMarketingPrompt = () => {
    dom.$consentPanel?.classList.add(CSS.cookieConsent);

    // If not using a facade, update the src of the iframe so the video loads and is ready to play
    if (dom.$iframe && !dom.$img) {
      const dataSrc = dom.$iframe.getAttribute("data-src");
      if (dataSrc) {
        dom.$iframe.src = dataSrc;
      }
    }
  };

  const acceptMarketingCookies = (event: MouseEvent) => {
    event.preventDefault();
    cookieConsentManager.acceptMarketingCookies();
  };

  const playFromFacade = (event: MouseEvent) => {
    event.preventDefault();

    // Check if marketing cookies are accepted before playing
    if (enableCookieGate && !cookieConsentManager.hasMarketingConsent()) {
      showMarketingPrompt();
      return;
    }

    if (dom.$iframe && dom.$img) {
      const dataSrc = dom.$iframe.getAttribute("data-src");
      if (dataSrc) {
        dom.$iframe.src = dataSrc;
        dom.$link?.classList.add(CSS.videoPlaying);
        dom.$iframe.removeAttribute("tabindex");
      }
    }
  };

  // Set up event listeners
  dom.$allowMarketingCookies?.addEventListener("click", acceptMarketingCookies);
  dom.$link?.addEventListener("click", playFromFacade);

  // Subscribe to cookie consent changes
  cookieConsentManager.subscribe({
    onMarketingAccepted: hideMarketingPrompt,
    onMarketingDenied: showMarketingPrompt,
  });
};

export default () => {
  const $videos = document.querySelectorAll<HTMLElement>(".js-video-with-facade");
  $videos.forEach(($element) => {
    instance($element);
  });
};
